module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Envoyer un email",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [(_vm.advanced) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "50px"
    }
  }, [_vm._v("\n      Design :\n      "), _c('el-select', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "placeholder": "Choix d'un design de mail"
    },
    model: {
      value: (_vm.form.options.view),
      callback: function($$v) {
        _vm.$set(_vm.form.options, "view", $$v)
      },
      expression: "form.options.view"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Devis B2B - Simple",
      "value": "clean-devis-b2b"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Devis B2B",
      "value": "devis-b2b"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "10px"
    }
  }), _vm._v("\n      Modèle :\n      "), _c('el-select', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "placeholder": "Choix d'un modèle de mail"
    },
    model: {
      value: (_vm.template),
      callback: function($$v) {
        _vm.template = $$v
      },
      expression: "template"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Envoi de factures",
      "value": "SEND_INVOICES"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.advanced) ? _c('el-form-item', {
    attrs: {
      "prop": "from",
      "label": "Expéditeur"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Expéditeur de l'email"
    },
    model: {
      value: (_vm.form.from),
      callback: function($$v) {
        _vm.$set(_vm.form, "from", $$v)
      },
      expression: "form.from"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "attachments",
      "label": "Pièces jointes"
    }
  }, _vm._l((_vm.form.attachments), function(url, name) {
    return _c('el-tag', {
      key: url
    }, [_vm._v("\n            " + _vm._s(name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "to",
      "label": "Destinataire"
    }
  }, [_c('tag-select', {
    attrs: {
      "value": _vm.form.to
    }
  })], 1), _vm._v(" "), (_vm.advanced) ? _c('el-form-item', {
    attrs: {
      "prop": "cc",
      "label": "Copie"
    }
  }, [_c('tag-select', {
    attrs: {
      "value": _vm.form.cc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('el-form-item', {
    attrs: {
      "prop": "bcc",
      "label": "Copie cachée"
    }
  }, [_c('tag-select', {
    attrs: {
      "value": _vm.form.bcc
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "subject",
      "label": "Sujet"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Saisissez le titre de l'email"
    },
    model: {
      value: (_vm.form.subject),
      callback: function($$v) {
        _vm.$set(_vm.form, "subject", $$v)
      },
      expression: "form.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "message",
      "label": "Contenu du message"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Saisissez le contenu de votre email"
    },
    model: {
      value: (_vm.form.message),
      callback: function($$v) {
        _vm.$set(_vm.form, "message", $$v)
      },
      expression: "form.message"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "pull-left",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  }, [_vm._v("Options avancées")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.submissionLoading
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Envoyer le mail")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20ef7fb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/EmailModal.vue
// module id = 675
// module chunks = 1